import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import RuleForm from './RuleForm'

const RuleCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create>
        <RuleForm />
      </Create>
    </SectionWrapper>
  )
}

export default RuleCreate
